import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Address } from "./Address";
import { PriceListDecoder } from "./PriceList";
import { User } from "./User";
export class Business extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.VATNumber = null;
        this.phone = "";
        this.email = "";
        this.address = Address.create({});
    }
}
__decorate([
    field({ decoder: StringDecoder })
], Business.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Business.prototype, "VATNumber", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Business.prototype, "phone", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], Business.prototype, "email", void 0);
__decorate([
    field({ decoder: Address })
], Business.prototype, "address", void 0);
export class ContactPerson extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.phone = "";
    }
}
__decorate([
    field({ decoder: StringDecoder })
], ContactPerson.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ContactPerson.prototype, "phone", void 0);
export class CustomerSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.business = null;
        /**
         * Default contact person used
         */
        this.contact = null;
        /**
         * List of known addresses of this customer. To provide a drop down experience.
         */
        this.addresses = [];
    }
}
__decorate([
    field({ decoder: Business, nullable: true })
], CustomerSettings.prototype, "business", void 0);
__decorate([
    field({ decoder: ContactPerson, nullable: true })
], CustomerSettings.prototype, "contact", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Address) })
], CustomerSettings.prototype, "addresses", void 0);
export class CustomerPrivateSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.priceList = null;
    }
}
__decorate([
    field({ decoder: PriceListDecoder, nullable: true })
], CustomerPrivateSettings.prototype, "priceList", void 0);
export class CreateCustomer extends AutoEncoder {
}
__decorate([
    field({ decoder: CustomerSettings })
], CreateCustomer.prototype, "settings", void 0);
export class Customer extends CreateCustomer {
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Customer.prototype, "id", void 0);
export class PrivateCustomer extends Customer {
    constructor() {
        super(...arguments);
        this.users = [];
        this.priceListIds = [];
    }
    get name() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.business) === null || _b === void 0 ? void 0 : _b.name) {
            return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.business) === null || _d === void 0 ? void 0 : _d.name;
        }
        if ((_f = (_e = this.settings) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.name) {
            return (_h = (_g = this.settings) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.name;
        }
        return (this === null || this === void 0 ? void 0 : this.users[0]) ? (this.users[0].firstName + " " + this.users[0].lastName) : "Lege klant";
    }
}
__decorate([
    field({ decoder: CustomerPrivateSettings })
], PrivateCustomer.prototype, "privateSettings", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(User) })
], PrivateCustomer.prototype, "users", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), version: 3 })
], PrivateCustomer.prototype, "priceListIds", void 0);
//# sourceMappingURL=Customer.js.map